// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604030803/js/" + chunkId + "." + {"44":"b28513fb","225":"ffbe4e36","481":"55260a12","486":"1d3f6c9f","770":"26cd0ba1"}[chunkId] + ".0.1079974925311673.chunk.js";
};